import { ManualReportTodoForm } from "@/components/forms/report/ManualReportTodoForm"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/test-support/rapportage-todo-aanmaken")({
  component: CreateManualReportTodoPage,
})

function CreateManualReportTodoPage() {
  return (
    <main className="mx-auto w-full max-w-5xl py-10">
      <h1 className="font-domine text-3xl font-bold text-primary-dark-blue">
        Rapportage todo handmatig aanmaken
      </h1>
      <p className="mt-2 mb-8 text-primary-dark-blue">
        Selecteer een cursist, rapporttype en medewerker. Bij meerdere
        contracten kies je ook het juiste contract.
      </p>
      <ManualReportTodoForm />
    </main>
  )
}
